import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import '../../../pages/staffing-page/d-staffing-statistics';
import type { AbsenceSummaryData } from '../summary-view';

/**
 * Absence summary component (Fraværsstatistikk)
 * Wraps d-staffing-statistics from staffing page
 */
@customElement('d-absence-summary')
export class DAbsenceSummary extends LitElement {
  @property({ type: Object })
  data!: AbsenceSummaryData;

  render() {
    return html`
      <d-staffing-statistics hide-header opened .employees=${this.data.employees}> </d-staffing-statistics>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'd-absence-summary': DAbsenceSummary;
  }
}
